import { OwnerEmpty } from "../shell/OwnerEmpty";

/**
 * An Agent address the Hub has no page for: someone else's, one that was
 * removed, one that never was. The Hub tells these three apart to nobody
 * (`hub/app.py` `NOT_YOURS`), so this says the same sentence it does, as an
 * empty state in the middle of the page with the one way back under it.
 */
export function AgentMissing() {
  return <OwnerEmpty icon="agent" action={<a className="btn btn-accent" href="/#/agents">回到我的 IP</a>}>
    打不开这个 IP：没有这个 IP，或者它不属于你。
  </OwnerEmpty>;
}
